import { FC } from 'react'
import { PaymentMethodsMobile } from './payment-methods-mobile'

export const PaymentMethods: FC = () => {

  return <PaymentMethodsMobile />
}
